module.exports = __webpack_public_path__ + "static/media/testStart.7b0fd52b.png";